import React from 'react';
import { colors } from '@/globalStyles';

const getFillColor = ({ primitiveProps, logicalType }) => {
  const { background_style } = primitiveProps;

  if (logicalType === 'hole') {
    return colors.white;
  } else if (background_style?.enabled) {
    return background_style.fill_color;
  }
  return colors.transparent;
};

const CircleComponent = props => {
  const { style, className, id, primitiveProps, withMiddleLines, logicalType, svgElementClickableRef } = props;
  const { x: cx, y: cy, radius: r, outline_style } = primitiveProps;
  const parsedStyle = JSON.parse(JSON.stringify(style));
  const styles = {
    ...parsedStyle,
    pointerEvents: className === 'decoration' ? 'none' : 'unset',
    ...(!parsedStyle.fill && { fill: getFillColor({ primitiveProps, logicalType }) }),
    ...(!parsedStyle.stroke && { stroke: outline_style && outline_style.enabled && outline_style.color ? outline_style.color : colors.black }),
  };

  return (
    <>
      <circle id={id} cx={cx} cy={cy} r={r} style={styles} ref={svgElementClickableRef} className={className} />
      {withMiddleLines && (
        <>
          <line style={{ pointerEvents: 'none' }} x1={cx - r} y1={cy} x2={cx + r} y2={cy} stroke={style.stroke} strokeWidth={style.strokeWidth} />
          <line style={{ pointerEvents: 'none' }} x1={cx} y1={cy - r} x2={cx} y2={cy + r} stroke={style.stroke} strokeWidth={style.strokeWidth} />
        </>
      )}
    </>
  );
};

export default CircleComponent;
